import { render, staticRenderFns } from "./WorkNav.vue?vue&type=template&id=34f80802&scoped=true&"
import script from "./WorkNav.vue?vue&type=script&lang=js&"
export * from "./WorkNav.vue?vue&type=script&lang=js&"
import style0 from "./WorkNav.vue?vue&type=style&index=0&id=34f80802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f80802",
  null
  
)

component.options.__file = "WorkNav.vue"
export default component.exports